import { IonAlert } from '@ionic/react'
import React from 'react'
import { goToPage } from '../../../helpers/app_actions'
import Api
 from '../../../services/Api'

interface ComponentProps {
  proModal: boolean
  setProModal: React.Dispatch<React.SetStateAction<boolean>>
  leaveModal: Function
}

const UpgradeAlert = ({proModal, setProModal, leaveModal} : ComponentProps) => {
  const api = Api.getInstance()

  return (
    <IonAlert
      isOpen={proModal}
      onDidDismiss={() => setProModal(false)}
      header="Walking Talking Pro"
      subHeader={api.tr('Upgrade_account')}
      message={api.tr('Upgrade_account_Info')}
      buttons={[
        {
          text: api.tr('cancel'),
          role: 'cancel',
          handler: () => {
            setProModal(false)
          },
        },
        {
          text: api.tr('Upgrade_leave_page'),
          role: 'confirm',
          handler: () => {
            leaveModal()
          },
        },
      ]}
  />
  )
}

export default UpgradeAlert